<template>
  <v-dialog v-model="isActive">
    <v-card>
      <v-card-title> Añadir fecha inhábil </v-card-title>
      <v-card-text>
        <AddDisabledDateForm @save="close"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import AddDisabledDateForm from "../Forms/AddDisabledDateForm.vue";

export default defineComponent({
  components: {
    AddDisabledDateForm,
  },
  props: ["isOpen"],
  setup(props, { emit }) {
    const isActive = ref(false);

    const close = () => {
      isActive.value = false;
      emit("close", false);
    };

    watch(
      () => props.isOpen,
      (newValue) => {
        isActive.value = newValue;
      }
    );

    return { isActive, close };
  },
});
</script>
